<ng-container *rxLet="vm$; let vm">
  <app-product-files-prompt [sectionNumber]="1"
                            [heroTitle]="vm.heroTitle"
                            sectionTitle="Entire Product Photo"
                            heroImage="assets/consumer-mobile/entire-product-file.svg"
                            messageBody="Show the entire damaged piece of furniture – stand far enough away to get the whole piece in the photo but close enough for it to fill the screen. Ideally, this photo should show the location of the damage."
                            (goToNextStep)="goToDamageFileUpload()"></app-product-files-prompt>
</ng-container>
